/* eslint-disable @box/blueprint/html-to-blueprint-mapping */
import Button from 'box-ui-elements/es/components/button';
import { Flyout, Overlay } from 'box-ui-elements/es/components/flyout';
import { white } from 'box-ui-elements/es/styles/variables';
import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import FontColorIcon from '../../../../../../assets/icons/rich-text-editor-icons/font-color';
import {
  highlightColors as highlightColorsMap,
  textColors as textColorsMap,
} from '../../../constants';
import messages from '../../../messages';
import css from './font-color-highlight-flyout.module.scss';

type Props = {
  handleSetColor: (color: string) => void;
  handleSetHighlight: (highlightColor: string) => void;
  isColorActive: (color: string) => boolean;
  isHighlightActive: (highlightColor: string) => boolean;
};

const textColors = Object.values(textColorsMap);
const highlightColors = Object.values(highlightColorsMap);

export const FontColorHighlightFlyout = ({
  handleSetColor,
  handleSetHighlight,
  isColorActive,
  isHighlightActive,
}: Props) => {
  const activeColorName = textColors.find(color => isColorActive(color));
  const activeHighlightColor = highlightColors.find(color =>
    isHighlightActive(color),
  );
  return (
    <Flyout position="bottom-center">
      <Button
        data-testid="font-color-button"
        icon={<FontColorIcon color={activeColorName} />}
        style={{ backgroundColor: activeHighlightColor }}
      />
      <Overlay className={css.overlay}>
        <div className={css.colorOverlayContent}>
          <div className={classnames(css.flexContent, css.textColorHeader)}>
            <div>
              <FontColorIcon height={12} width={12} />
            </div>
            <span>
              <FormattedMessage {...messages.textColor} />
            </span>
          </div>
          <div className={css.textColorButtonContainer}>
            {textColors.map(color => (
              <Button
                key={color}
                className={css.textColorButton}
                data-testid="text-color-button"
                onClick={() => handleSetColor(color)}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
          <div
            className={classnames(css.flexContent, css.textHightlightHeader)}
          >
            <div>
              <FontColorIcon color="white" height={12} width={12} />
            </div>
            <span>
              <FormattedMessage {...messages.textHighlight} />
            </span>
          </div>
          <div className={css.textColorButtonContainer}>
            <button
              className={classnames(
                css.textColorButton,
                css.textHightNoneButton,
              )}
              data-testid="clear-highlight-color-button"
              onClick={() => handleSetHighlight(white)}
              type="button"
            >
              <span className={css.textHightNoneSpan}>
                <span className={css.redLine} />
              </span>
            </button>
            {highlightColors.map(color => (
              <Button
                key={color}
                className={css.textColorButton}
                data-testid="highlight-color-button"
                onClick={() => handleSetHighlight(color)}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
          <div />
        </div>
      </Overlay>
    </Flyout>
  );
};
